import FloatingActionButton from 'emerald-ui/lib/FloatingActionButton';
import populateDocs from './utils/populateDocs';

export default {
  ...populateDocs([{ component: FloatingActionButton, componentName: 'FloatingActionButton' }], 'FloatingActionButton'),
  description:
    'The FloatingActionButton is used for the main call to action of a page. Only one must be present in a page and preferably, above the fold.',
  codeSamples: [
    {
      title: 'Default',
      scope: { FloatingActionButton },
      whiteBackground: true,
      code: `<FloatingActionButton
  icon="add"
  ariaLabel="Add item"
/>`,
    },
  ],
};
